module.exports = __webpack_public_path__ + "img/icon-share-portfolio.1ff7decf.svg";